import {IfProps} from "../../types";

const If = ({children, condition}: IfProps) => {
    return (condition ?
            <>
                {children}
            </>
            : <></>
    )
}

export default If;
